import store from '@/store';
import { MixpanelEvents } from './events.enum';
import mixpanel, { Dict } from 'mixpanel-browser';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { useGetters as rootGetters } from 'vuex-composition-helpers';

const { useGetters } = createNamespacedHelpers(store, 'authentication');

export interface EventProperty {
  label: string;
  value: string | boolean | number;
}

export default class MixpanelService {
  private properties: Dict = {};

  public track(event: MixpanelEvents | string, props?: EventProperty[]): void {
    try {
      this.setVisitIdentity();
    } catch (error) {
      //fail silently
    }
    props?.forEach((p) => {
      this.properties[p.label] = p.value;
    });

    mixpanel.track(event, this.properties);
  }

  async setVisitIdentity() {
    const { name, email } = await useGetters(['name', 'email']);
    const { partnerID } = await rootGetters(store, ['partnerID']);

    if (partnerID.value) {
      mixpanel.identify(partnerID.value);

      if (partnerID.value) {
        this.properties['Partner ID'] = partnerID.value || '';
      }
      if (name.value) {
        this.properties['Partner Name'] = name.value || '';
      }
      if (email.value) {
        this.properties['Partner Email'] = email.value || '';
      }
      return;
    }

    mixpanel.reset();
  }
}
